import {
  exposeChangeTimer,
  initTimers,
} from '../../components/ScreenSaver/timerUtils';
import { useKioskIntegration } from '../../hooks/useKioskIntegration';
import { applicationSettings } from '../../settings/application';
import platform from '../../util/platform';

const setUpScreensaverTimers = () => {
  const { isUpptacka } = useKioskIntegration();

  // when app starts first time it has no timer-values in sessionStorage
  if (!sessionStorage.getItem('screenSaverTimers')) {
    initTimers();
  }

  // used by typing in changeScreenSaverTimers()
  // in the console. for the screensaver to
  // never appear use changeScreenSaverTimers('never')
  if (!applicationSettings.isProd && platform.isKiosk && !isUpptacka) {
    exposeChangeTimer();
  }
};

export default setUpScreensaverTimers;
